const __WEBPACK_NAMESPACE_OBJECT__ = window["svs"]["ui"]["ReactIcon"];